import { Core } from "@/core/Core";

export default {

  /* Variants */

  async getVariants(context, {inventoryId, id, augment}) {
    try {
      return await Core.request("GET", `/api/inventory/${inventoryId}/variants`, {id, augment, admin: true});
    } catch (e) {
      return null;
    }
  },

}